import { useShop } from "hooks/firestore/simple/useShop"

export function useStorefrontId() {
  const currentShop = useShop()
  const storefrontId = currentShop?.offering?.storefrontId
  return storefrontId
}
